import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=2ca12208&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&id=2ca12208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca12208",
  null
  
)

export default component.exports